import { useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";

import SearchBar from "../../components/SearchBar";
import AddTicket from "../../Modals/addTicket";

interface QuesData {
  id: number;
  productId: string;
  productName: string;
  category: string;
  subcategory: string;
  questions: number;
}

const QuesAns = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [quesData, setQuesData] = useState<QuesData[]>([
    {
      id: 1,
      productId: "P001",
      productName: "Organic Shampoo",
      category: "Beauty",
      subcategory: "Hair Care",
      questions: 5,
    },
    {
      id: 2,
      productId: "P002",
      productName: "Running Shoes",
      category: "Footwear",
      subcategory: "Sports",
      questions: 12,
    },
  ]);

  // Filter data by search
  const filteredData = quesData.filter(
    (item) =>
      item.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.productId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.subcategory.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="main_title">
        <h1>Questions and Answers</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Questions and Answers
        </p>
      </div>

      <div className="cards">

        {/* Search + Add */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
        
        </div>

        {/* Table */}
        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Product ID</TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Subcategory</TableCell>
                <TableCell>No. of Questions</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow key={row.id} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.productId}</TableCell>
                  <TableCell>{row.productName}</TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>{row.subcategory}</TableCell>
                  <TableCell>{row.questions}</TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={()=> navigate("view")}>
                        <img src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>

                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}

              {filteredData.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

    </>
  );
};

export default QuesAns;
